import { render, staticRenderFns } from "./development.vue?vue&type=template&id=f505e480"
import script from "./development.vue?vue&type=script&lang=js"
export * from "./development.vue?vue&type=script&lang=js"
import style0 from "./development.vue?vue&type=style&index=0&id=f505e480&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports